var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "菜品分配档口",
        width: 560,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form",
        {
          staticStyle: { "margin-bottom": "12px" },
          attrs: { layout: "inline" },
        },
        [
          _c("a-input-search", {
            staticStyle: { width: "260px" },
            attrs: { placeholder: "搜索菜品名称", enterButton: "" },
            on: { search: _vm.loadGoods },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c(
        "a-form-item",
        {
          staticStyle: { "margin-bottom": "12px" },
          attrs: {
            label: "分配到档口",
            labelCol: { span: 5 },
            wrapperCol: { span: 17, offset: 1 },
          },
        },
        [
          _c(
            "a-select",
            {
              attrs: {
                placeholder: "选择档口（选「清除档口」则取消分配）",
                "allow-clear": "",
              },
              model: {
                value: _vm.stationId,
                callback: function ($$v) {
                  _vm.stationId = $$v
                },
                expression: "stationId",
              },
            },
            _vm._l(_vm.stations, function (s) {
              return _c(
                "a-select-option",
                { key: s.id, attrs: { value: s.id } },
                [_vm._v(_vm._s(s.name))]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("a-table", {
        attrs: {
          size: "small",
          bordered: "",
          rowKey: "materialId",
          rowSelection: {
            selectedRowKeys: _vm.selectedRowKeys,
            onChange: _vm.onSelect,
          },
          columns: _vm.columns,
          dataSource: _vm.goods,
          loading: _vm.loading,
          pagination: false,
          scroll: { y: 320 },
        },
        scopedSlots: _vm._u([
          {
            key: "stationSlot",
            fn: function (text) {
              return [_vm._v(_vm._s(_vm.stationName(text)))]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }